import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import PointerEvents from "../../core/src/const/PointerEvents";
import CommManager from "../../core/src/controllers/CommManager";
import GameModel from "../../core/src/model/GameModel";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import { IRealityCheckData } from "../../core/src/server/data/IRealityCheckData";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import { RealityCheckState } from "../../core/src/states/RealityCheckState";
import UIController from "../../core/src/ui/UIController";
import { UIStates } from "../../core/src/ui/UIStates";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import { DefaultLayers } from "../../core/src/utils/Layers";
import Locale, { LocaleId } from "../../core/src/utils/Locale";
import ViewManager from "../../core/src/utils/ViewManager";

export default class VendorRealityCheckState extends RealityCheckState {

    constructor(stateMachine) {
        super(stateMachine);
    }

    protected initRealityCheck() {
        UIController.setState(UIStates.SPIN);
        CommandManager.execute(Commands.CLOSE_SETTINGS);
            CommManager.send(RequestRegister.get("pingRequest"), (data) => {
                RealityCheckModel.totalSessionMinutes = data.realityCheck.totalSessionMinutes;
                this.showRealityCheck();
            }, true)
    }

    protected showRealityCheck() {
        ViewManager.getLayer("SplashOverlay").setScene("open");


        const elapsedTime = RealityCheckModel.milliSecToMin(
            RealityCheckModel.getElapsedTime()
        );
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "realityCheck"
        );

        // Set title label
        scene.sceneTextFields.get("title").text = Locale.getString(
            LocaleId.rc_title_session_length
        );

        // Set message body
        let messageBody = Locale.getString(LocaleId.rc_session_tie);

        scene.sceneTextFields.get("text").text = messageBody;

        // Set continue button
        const exitButton = scene.buttons.get("continue");
        exitButton.setValue(Locale.getString(LocaleId.but_cp));
        exitButton.on(PointerEvents.DOWN, () => {
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            // Clear limit
            CommManager.send(
                RequestRegister.get("resetRealityCheck"),
                (data) => {
                    ConsoleUtil.log("[AuthState] Reset RC response", data);
                    // Also reset the model
                    RealityCheckModel.update(<IRealityCheckData>{
                        sessionMinutes: 0
                    });
                    // reset sessionStartTimer
                    RealityCheckModel.sessionStartTime = Date.now();
                    // Hide the overlay
                    ViewManager.getLayer("SplashOverlay").clear();

                    // Then exit the state
                    this.exit();
                },
                this,
                (err) => {
                    this.handleError(err);
                }
            );
        });

        // Set lobby button
        const lobbyButton = scene.buttons.get("lobby");
        lobbyButton.setValue(Locale.getString(LocaleId.but_rl));
        lobbyButton.on(PointerEvents.DOWN, () => {
        
            CommandManager.execute(Commands.GO_HOME);

        //  it's not need to clear layer or exit to state
        //  because GO_HOME will redirect to another window
        //  we have an issue from Relax that invoce balance update
        //  if we exit from this state
        //  ViewManager.getLayer(DefaultLayers.Popups).clear();
        //  Then exit the state
        //  this.exit();
        });

        // Set account history button
        const historyButton = scene.buttons.get("history");
        historyButton.setValue(Locale.getString(LocaleId.but_ah));

        if (GameModel.urlParams.rchistoryurl) {
            // ONLY up event works on iOS!!!
            historyButton.on(PointerEvents.UP, () => {
                CommandManager.execute(Commands.OPEN_RC_HISTORY);
            });
        } else {
            historyButton.setVisible(false);
        }
    }
}